import React from 'react';

import DeployCohortCoursewareModal from './DeployCohortCoursewareModal';

function DeployCohortCoursewareWrapper(props) {
  return (
    <DeployCohortCoursewareModal {...props} />
  );
}

export default DeployCohortCoursewareWrapper;
